import { Flex, Image, Text } from '@cmpsr/components';
import { QuestionnaireLoadingProps } from '../types';
import useProgressStepListController from './progress-step-list.controller';

export default function ProgressStepList({
  isFirstTimeLoadingResults,
  isCalculationComplete,
}: QuestionnaireLoadingProps) {
  const { stepsList, currentStep, getTextStyles, checkImage } =
    useProgressStepListController(isFirstTimeLoadingResults);

  return (
    <Flex flexDir="column" gap={{ base: 'spacer-4', lg: 'spacer-6' }}>
      {stepsList.map((step, index) => (
        <Flex key={index} alignItems="center" gap="spacer-2">
          <Image w="24px" h="24px" src={checkImage(isCalculationComplete, currentStep, index)} />
          <Text {...getTextStyles(isCalculationComplete, currentStep, index)}>{step}</Text>
        </Flex>
      ))}
    </Flex>
  );
}
